import { IItem } from '@bimser/core';
import { GetIconComponent } from '@bimser/icons';
import IconDelete from '@bimser/icons/16/delete';
import IconMore from '@bimser/icons/16/more';
import classNames from 'classnames/bind';
import * as React from 'react';
import { BCDropdownWrapper, findMessage } from '../';
import Styles from './assets/listEditorStyle.scss';
import { IListEditorItem, IListEditorItemProps } from './entities';

const cx = classNames.bind(Styles);

const ListEditorItem = (props: IListEditorItemProps) => {
	const getItem = (): IListEditorItem => ({
		icon: props.icon,
		id: props.id,
		selected: props.selected,
		showDelete: props.showDelete,
		subText: props.subText,
		text: props.text,
		externalData: props.externalData,
		subTextPrefix: props.subTextPrefix
	});

	const onSelect = () => {
		props.onSelect?.(getItem());
	};

	const onDelete = () => {
		if (props.showDelete) {
			props.onDelete?.(getItem());
		}
	};

	const onSelectDelete = () => {
		if (props.showSelectDelete) {
			props.onSelectDelete?.(getItem());
		}
	};

	const renderSubText = () => {
		if (props.subText) {
			if (props.subTextPrefix) {
				return (
					<div>
						<span className={Styles.serverText}>{props.subTextPrefix}</span>
						<p>{props.subText}</p>
					</div>
				);
			} else {
				return (
					<div>
						<p>{props.subText}</p>
					</div>
				);
			}
		}
	};

	const renderTypeItem = (item: any) => (
		<div
			className={Styles.removeTypeItem}
			onClick={onDelete}
		>
			<IconDelete />
			<span>{item.text}</span>
		</div>
	);

	const renderSelectItem = (item: any) => (
		<div
			className={Styles.removeTypeItem}
			onClick={onSelectDelete}
		>
			<IconDelete />
			<span>{item.text}</span>
		</div>
	);

	const renderDelete = () => {
		if (!props.showDelete && !props.showSelectDelete) {
			return <></>;
		}

		const typeMenuProps: { items: IItem[] } = { items: [] };

		if (props.showDelete) {
			typeMenuProps.items.push({
				key: 'delete',
				text: findMessage.get('100013'),
				icon: IconDelete.info,
				className: Styles.menuTypeItem,
				customTemplate: renderTypeItem
			});
		}

		if (props.showSelectDelete) {
			typeMenuProps.items.push({
				key: 'selectDelete',
				text: findMessage.get('102949'),
				icon: IconDelete.info,
				className: Styles.menuTypeItem,
				customTemplate: renderSelectItem
			});
		}

		return (
			<BCDropdownWrapper
				trigger={['click']}
				stopPropagation
				menuProps={typeMenuProps}
			>
				<div className={Styles.moreIcon}>
					<IconMore className={Styles.removeButton} />
				</div>
			</BCDropdownWrapper>
		);
	};

	const renderIcon = () => {
		if (props.iconType === 'icon') {
			return GetIconComponent(props.icon);
		} else {
			return (
				<div
					className={Styles.custom}
					style={{ background: props.text }}
				/>
			);
		}
	};

	const renderText = (): React.ReactNode => {
		if (props.renderCustomListItemText) {
			return props.renderCustomListItemText(getItem());
		}
		return <h3>{props.text}</h3>;
	};

	const classNames = cx({
		item: true,
		selected: props.selected
	});

	return (
		<div
			id={props.id}
			onClick={onSelect}
			className={classNames}
		>
			<div className={Styles.icon}>{renderIcon()}</div>
			<div className={Styles.listItemContent}>
				{renderText()}
				{renderSubText()}
			</div>
			{renderDelete()}
		</div>
	);
};
export default ListEditorItem;
export { IListEditorItemProps };
